// extracted by mini-css-extract-plugin
export default {"modal":"SwitchToAppModal_modal__h0cVy","body":"SwitchToAppModal_body__93kHU","btn":"SwitchToAppModal_btn__u89qa"};